module.exports = __webpack_public_path__ + "img/stat2.cc2ba4c6.svg";